/* Flavourful Bites product page interactions. */
(function () {
  const money = (cents, symbol) => {
    const value = cents / 100;
    const digits = Number.isInteger(value) ? 0 : 2;
    return symbol + value.toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: 2 });
  };
  const root = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  /* Adds lines to the cart. With the cart drawer present it does the add and opens the drawer
     (opts.open === false skips opening, e.g. for Buy now); otherwise it refreshes the header bubble. */
  async function addToCart(items, opts = {}) {
    if (window.fbCart) return window.fbCart.add(items, opts);
    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-icon-bubble', sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || res.statusText);
    const html = data.sections && data.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) {
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (section) bubble.innerHTML = section.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('fb:cart-updated', { detail: data }));
    return data;
  }

  function flash(button, label, restore) {
    const original = restore ?? button.innerHTML;
    button.textContent = label;
    setTimeout(() => {
      button.innerHTML = original;
      button.disabled = false;
    }, 1800);
  }

  /* Gallery, quantity, add to cart, buy now, pincode check and coupon copy. */
  class FbPdpMain extends HTMLElement {
    connectedCallback() {
      this.qty = 1;
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.symbol = this.dataset.currency || '';
      this.variantId = parseInt(this.dataset.variantId, 10);
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.counter = this.querySelector('[data-counter]');
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(parseInt(t.dataset.thumb, 10))));
      this.querySelectorAll('[data-play]').forEach((b) => b.addEventListener('click', () => this.play(b.closest('[data-video]'))));

      this.querySelector('[data-qty-dec]')?.addEventListener('click', () => this.setQty(this.qty - 1));
      this.querySelector('[data-qty-inc]')?.addEventListener('click', () => this.setQty(this.qty + 1));
      this.form = this.querySelector('[data-buy-form]');
      this.form?.addEventListener('submit', (e) => {
        e.preventDefault();
        this.add(e.submitter && e.submitter.hasAttribute('data-buy-now'));
      });

      this.pin = this.querySelector('[data-pin]');
      this.pinResult = this.querySelector('[data-pin-result]');
      this.querySelector('[data-pin-check]')?.addEventListener('click', () => this.checkPin());
      this.pin?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.checkPin();
        }
      });
      this.pin?.addEventListener('input', () => (this.pin.value = this.pin.value.replace(/\D/g, '').slice(0, 6)));

      this.querySelectorAll('[data-copy]').forEach((b) => b.addEventListener('click', () => this.copy(b)));
      window.fbPdp = this;
    }

    show(i) {
      this.items.forEach((el, k) => {
        el.hidden = k !== i;
        if (k !== i) {
          const v = el.querySelector('video');
          if (v) v.pause();
        }
      });
      this.thumbs.forEach((t) => t.setAttribute('aria-current', parseInt(t.dataset.thumb, 10) === i ? 'true' : 'false'));
      if (this.counter) this.counter.textContent = i + 1 + ' / ' + this.items.length;
    }

    play(overlay) {
      const tpl = overlay && overlay.querySelector('template');
      if (!tpl) return;
      const item = overlay.closest('[data-item]');
      item.innerHTML = '';
      item.appendChild(tpl.content.cloneNode(true));
      const video = item.querySelector('video');
      if (video) video.play().catch(() => {});
    }

    setQty(q) {
      this.qty = Math.max(1, Math.min(10, q));
      this.querySelector('[data-qty]').textContent = this.qty;
      this.querySelector('[data-qty-input]').value = this.qty;
      const label = this.querySelector('[data-add-text]');
      if (label && !this.querySelector('[data-add]').disabled) label.textContent = this.dataset.addLabel + ' · ' + money(this.price * this.qty, this.symbol);
      document.dispatchEvent(new CustomEvent('fb:qty', { detail: { qty: this.qty, total: this.price * this.qty, symbol: this.symbol } }));
    }

    async add(buyNow, button) {
      const btn = button || this.querySelector(buyNow ? '[data-buy-now]' : '[data-add]');
      const error = this.querySelector('[data-error]');
      const restore = btn.innerHTML;
      btn.disabled = true;
      if (error) error.hidden = true;
      try {
        await addToCart([{ id: this.variantId, quantity: this.qty }], { open: !buyNow, trigger: btn });
        if (buyNow) {
          window.location.href = this.dataset.checkoutUrl || '/checkout';
          return;
        }
        if (window.fbCart) btn.disabled = false;
        else flash(btn, this.dataset.addedLabel || 'Added', restore);
      } catch (e) {
        btn.disabled = false;
        if (error) {
          error.hidden = false;
          error.textContent = e.message;
        } else {
          alert(e.message);
        }
      }
    }

    checkPin() {
      const pin = (this.pin.value || '').trim();
      const r = this.pinResult;
      r.hidden = false;
      r.classList.remove('is-bad');
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        r.classList.add('is-bad');
        r.textContent = this.dataset.pinInvalid;
        return;
      }
      const list = (this.dataset.pinList || '').split(/[\s,]+/).filter(Boolean);
      const ok = !list.length || list.some((p) => pin.startsWith(p));
      if (ok) {
        r.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
        r.append(document.createTextNode(this.dataset.pinOk));
      } else {
        r.classList.add('is-bad');
        r.textContent = this.dataset.pinNo;
      }
    }

    async copy(button) {
      const code = button.dataset.copy;
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const t = document.createElement('textarea');
        t.value = code;
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (err) {}
        t.remove();
      }
      this.querySelectorAll('[data-copy].is-copied').forEach((b) => {
        b.classList.remove('is-copied');
        b.textContent = b.dataset.copy + ' · ' + b.dataset.copyLabel;
      });
      if (!button.dataset.copyLabel) button.dataset.copyLabel = button.textContent.split(' · ').pop();
      button.classList.add('is-copied');
      button.textContent = button.dataset.copiedLabel;
    }
  }

  /* Desktop tabs for product details (mobile uses <details>). */
  class FbPdpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
      const current = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      this.select(current < 0 ? 0 : current);
    }

    select(i) {
      this.tabs.forEach((t, k) => {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = k !== i;
      });
    }
  }

  /* Make it a Trio: current product locked, others toggle, discount preview, one add request. */
  class FbPdpTrio extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('[data-tile]'));
      this.symbol = this.dataset.currency || '';
      this.pct = parseFloat(this.dataset.pct) || 0;
      this.need = this.tiles.length;
      this.tiles.forEach((tile) => {
        const check = tile.querySelector('[data-check]');
        if (tile.classList.contains('is-locked')) return;
        check.addEventListener('click', () => {
          const on = tile.dataset.on !== 'true';
          tile.dataset.on = on;
          check.setAttribute('aria-checked', on);
          this.render();
        });
      });
      this.button = this.querySelector('[data-add-trio]');
      this.button.addEventListener('click', () => this.add());
      this.render();
    }

    render() {
      const on = this.tiles.filter((t) => t.dataset.on === 'true');
      const n = on.length;
      const sub = on.reduce((s, t) => s + parseInt(t.dataset.price, 10), 0);
      const all = n === this.need && this.need >= 3;
      const disc = all ? Math.round((sub * this.pct) / 100 / 100) * 100 : 0;
      this.querySelector('[data-count]').textContent = n === 1 ? this.dataset.countOne : this.dataset.countMany.replace('[n]', n);
      this.querySelector('[data-total]').textContent = money(sub - disc, this.symbol);
      const was = this.querySelector('[data-sub]');
      was.hidden = !disc;
      was.textContent = money(sub, this.symbol);
      const hint = this.querySelector('[data-hint]');
      hint.classList.toggle('is-done', !!disc);
      hint.textContent = disc
        ? this.dataset.hintDone.replace('[save]', money(disc, this.symbol)).replace('[pct]', this.pct)
        : this.dataset.hintMore.replace('[n]', Math.max(1, 3 - n)).replace('[pct]', this.pct);
      this.button.textContent = this.dataset.cta.replace('[n]', n);
    }

    async add() {
      const items = this.tiles
        .filter((t) => t.dataset.on === 'true' && t.dataset.variant)
        .map((t) => ({ id: parseInt(t.dataset.variant, 10), quantity: 1 }));
      const error = this.querySelector('[data-error]');
      if (!items.length) return;
      this.button.disabled = true;
      error.hidden = true;
      try {
        await addToCart(items, { trigger: this.button });
        if (!window.fbCart) window.location.href = this.dataset.cartUrl || '/cart';
        this.button.disabled = false;
      } catch (e) {
        error.hidden = false;
        error.textContent = e.message;
        this.button.disabled = false;
      }
    }
  }

  /* Sticky add-to-cart bar: mirrors quantity; on desktop it slides in once the buy box button has scrolled away. */
  class FbPdpSticky extends HTMLElement {
    connectedCallback() {
      this.symbol = this.dataset.currency || '';
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.onQty = (e) => {
        this.querySelectorAll('[data-sticky-qty]').forEach((el) => (el.textContent = e.detail.qty));
        const total = money(e.detail.total, this.symbol);
        this.querySelector('[data-sticky-total]').textContent = total;
        this.querySelector('[data-sticky-label]').textContent = this.dataset.addLabel + ' · ' + total;
      };
      document.addEventListener('fb:qty', this.onQty);
      this.querySelector('[data-sticky-add]').addEventListener('click', (e) => window.fbPdp && window.fbPdp.add(false, e.currentTarget));
      this.querySelector('[data-sticky-buy]').addEventListener('click', (e) => window.fbPdp && window.fbPdp.add(true, e.currentTarget));
      const target = document.querySelector('fb-pdp-main [data-add]');
      if (target && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.io.observe(target);
      } else {
        this.classList.add('is-visible');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('fb:qty', this.onQty);
      this.io?.disconnect();
    }
  }

  /* "+ Add" buttons on the family cards. */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    const restore = btn.innerHTML;
    btn.disabled = true;
    try {
      await addToCart([{ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }], { trigger: btn });
      if (window.fbCart) btn.disabled = false;
      else flash(btn, btn.dataset.addedLabel || 'Added', restore);
    } catch (err) {
      btn.disabled = false;
      alert(err.message);
    }
  });

  const define = (name, cls) => customElements.get(name) || customElements.define(name, cls);
  define('fb-pdp-main', FbPdpMain);
  define('fb-pdp-tabs', FbPdpTabs);
  define('fb-pdp-trio', FbPdpTrio);
  define('fb-pdp-sticky', FbPdpSticky);
})();
